import CustomElement from '../core/custom.js'
import 'flickity/dist/flickity.min.css'
import Flickity from 'flickity'
import remapRange from '../utilities/remapRange.js'
import clamp from '../utilities/clamp.js'
import Viewport from '../stores/viewport.js'

import Emitter from '../core/emitter.js'

export default window.customElements.define(
  'cover-flow-slider',
  class extends CustomElement {
    scaleMin = 0.5

    constructor() {
      super()

      this.events = {
        'click .js-prev': '_onPrev',
        'click .js-next': '_onNext'
    }

      this._onResize = this.onResize.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()

      this.$slider = this.querySelector('.js-slider')
      this.$prev = this.querySelector('.js-prev')
      this.$next = this.querySelector('.js-next')

      if (!this.$slider) {
        return console.warn(
          'CoverFlowSlider: This component must be have a .js-slider child',
          this
        )
      }

      this._flkty = new Flickity(this.$slider, {
        resize: false,
        prevNextButtons: false,
        pageDots: false,
        friction: 0.3,
        cellAlign: 'center',
        wrapAround: false
      })

      this._cellElements = this._flkty.getCellElements()
      this._count = this._flkty.slides.length - 1

      const first = this._cellElements[0]
      first.style.zIndex = 1

      
      this._flkty.on('scroll', (progress) => {
        this._progress = progress
        this._flkty.slides.forEach(this.applyTransforms.bind(this))
      })
      
      this.disableSlides(this._flkty.selectedIndex)
      this.$prev.style.opacity = 0

      this._flkty.on('change', (index) => {
        this.disableSlides(index)

        this.$prev.style.opacity = (index === 0) ? 0 : 1
        this.$next.style.opacity = (index === this._count) ? 0 : 1
      })

      // Disabled click on link during drag
      this._flkty.on('dragMove', () => {
        this.$slider.style.pointerEvents = 'none'
      })

      this._flkty.on('dragEnd', () => {
        this.$slider.style.pointerEvents = null
      })

      this._flkty.on( 'staticClick', ( event, pointer, cellElement, cellIndex ) => {
        if ( !cellElement ) {
          return;
        }
        // var len = flkty.cells.length;
        // cellIndex = getClosestIndex( cellIndex, flkty.selectedIndex, len );
        // cellIndex = getClosestIndex( cellIndex, flkty.selectedIndex, -len );
        this._flkty.select( cellIndex, false, false )
      });


      // Synchronise resize
      Emitter.on('resize', this._onResize)

      this.onResize()
    }

    onBreakpoint({ matches: isLg }) {
      this.scaleMin = isLg ? 0.5 : 0.8
    }

    disableSlides(index) {
      this._flkty.slides.forEach((slide, i) => {
        const el = this._cellElements[i]

        if (index === i) {
          el.style.zIndex = 1
          el.setAttribute('data-disabled', false)
        } else {
          el.style.zIndex = 0
          el.setAttribute('data-disabled', true)
        }
      })
    }

    applyTransforms(slide, i) {
      const el = this._cellElements[i]

      let ratio = i - this._progress * this._count
      const offset = Viewport.width / 6 + 20

      // these tests give a little buggy loop
      // if (i == this._count && this._flkty.selectedIndex == 0) {
      //   ratio = -1 - this._progress
      // } else if (i == 0 && this._flkty.selectedIndex == this._count) {
      //   ratio = 1
      // } else if (
      //   i == this._count &&
      //   this._flkty.selectedIndex == this._count - 1
      // ) {
      //   ratio = 1
      // }

      let translateX, scale
      // Make transforms
      if (Math.sign(ratio) === -1) {
        scale = remapRange(0, -1, 1, this.scaleMin, ratio)
        translateX = remapRange(0, -1, 0, offset, ratio)
      } else {
        scale = remapRange(0, 1, 1, this.scaleMin, ratio)
        translateX = remapRange(0, 1, 0, -offset, ratio)
      }
      scale = clamp(scale, this.scaleMin, 1)
      // translateX= clamp(translateX, -offset, offset)

      // Apply transforms
      // el.firstElementChild.style.transform = `translateX(${translateX}px) scale(${scale})`
      el.style.transform = `translateX(${translateX + slide.x}px) scale(${scale})`
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      Emitter.off('resize', this._onResize)
    }

    onResize() {
      this._flkty.resize()
      this._flkty.slides.forEach(this.applyTransforms.bind(this))

      const img = this.querySelector('.js-img')

      this._cellElements.forEach((slide) => {
        slide.firstElementChild.style.transformOrigin = `center ${
          img.offsetHeight / 2
        }px`
      })
    }

    _onPrev() {
      this._flkty.previous()
    }

    _onNext() {
      this._flkty.next()
    }
  }
)
